const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// mainSlider
// ----- BOTH
// ------------------------------------------------------------------------
const mainSlider = () => {
  $('.slider').slick({
    // autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    focusOnSelect: true,
    responsive:[
      {
          breakpoint: 768,
          settings:{
              slidesToShow:2,
          }
      },
    ]
  });
};

// ------------------------------------------------------------------------
// lowSlider
// ----- BOTH
// ------------------------------------------------------------------------
const lowSlider = () => {
  $('.slider').slick({
    // autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    centerMode: true,
    variableWidth: true,
    focusOnSelect: true,
    responsive:[
      {
          breakpoint: 768,
          settings:{
              slidesToShow:2,
          }
      },
    ]
  });
};


// ------------------------------------------------------------------------
// headerResize
// ----- BOTH
// ------------------------------------------------------------------------
const headerResize = () => {
  $(window).on("scroll load", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 200) {
      $(".st-Header").addClass("scrolled");
      $(".st-Header_Inner").addClass("scrolled");
    } else {
      $(".st-Header").removeClass("scrolled");
      $(".st-Header_Inner").removeClass("scrolled");
    }
  });
};


//言語切替メニュー
const studioHover = () => {
  let count = 0;
  const delay = 500;
  $('.btn-studio,.st-Header_Studio').mouseenter(function() {
    count++;
    $(".st-Header_Studio").addClass('in');
  }).mouseleave(function() {
    count--;
    setTimeout(function() {
      if (!count) {
        $(".st-Header_Studio").removeClass('in');
        $(".st-Header_Studio").addClass('out');
        setTimeout(function() {
          $(".st-Header_Studio").removeClass('out');
        }, 500);
      }
    }, delay);
  });
  $(window).scroll(function() {
    $(".st-Header_Studio").removeClass('in');
    $(".st-Header_Studio").removeClass('out');
  });
};

// ------------------------------------------------------------------------
// toggleMenu
// ----- BOTH
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.st-Header_Hamburger > button').on('click', function() {
    $(this).toggleClass("close");
    $(".st-Header_Hamburger").toggleClass("open");
    $(".st-Header_Slide").toggleClass("open");
  });
};

export {
  anchorLink,
  mainSlider,
  lowSlider,
  headerResize,
  studioHover,
  toggleMenu
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js